// Conta ao vivo "venda de R$ X → você recebe R$ Y em DD/MM". Mesma regra do
// servidor (services/taxas_pagamento.py): % + fixa, nunca mais que a venda,
// prazo em dias corridos a partir de hoje.

export const reais = (v) => (Number(v) || 0).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
export const pct = (v) => `${(Number(v) || 0).toLocaleString("pt-BR", { maximumFractionDigits: 3 })}%`;

export function simular(venda, { taxa_percentual, taxa_fixa, prazo_dias }) {
  const valor = Number(venda) || 0;
  const bruta = valor * (Number(taxa_percentual) || 0) / 100 + (Number(taxa_fixa) || 0);
  const taxa = Math.min(Math.round(bruta * 100) / 100, valor);
  const cai = new Date();
  cai.setDate(cai.getDate() + (parseInt(prazo_dias, 10) || 0));
  return { taxa, recebe: valor - taxa, data: cai.toLocaleDateString("pt-BR", { day: "2-digit", month: "2-digit" }) };
}

export const rotuloPrazo = (dias) => {
  const d = parseInt(dias, 10) || 0;
  return d === 0 ? "na hora" : d === 1 ? "no dia seguinte" : `em ${d} dias`;
};
